/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldInfo
 */
export interface FieldInfo {
    /**
     * 
     * @type {string}
     * @memberof FieldInfo
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldInfo
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfo
     */
    required?: boolean | null;
}

/**
 * Check if a given object implements the FieldInfo interface.
 */
export function instanceOfFieldInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FieldInfoFromJSON(json: any): FieldInfo {
    return FieldInfoFromJSONTyped(json, false);
}

export function FieldInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'required': !exists(json, 'required') ? undefined : json['required'],
    };
}

export function FieldInfoToJSON(value?: FieldInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'required': value.required,
    };
}

